import { IPolicy, TPolicyType } from "../types";
import { Invitation } from "../services/invitation/invitation.service";

export const transformPolicyType = (
  type: TPolicyType,
  short?: boolean,
): string => {
  switch (type) {
    case "wc":
      return short ? "WC" : "Workers compensation (WC)";
    case "cpx":
      return short ? "CPX" : "Commercial pack extra (CPX)";
    case "bpk":
    default:
      return short ? "BPK" : "Business pack (BPK)";
  }
};

export type InvitationStatus = "doNotInvite" | "invite" | "invited" | undefined;

export const invitationStatus = (policy: IPolicy): InvitationStatus => {
  const someClaimed = policy.invitations?.some(
    (invite: Invitation) => invite?.status === "claimed",
  );

  const someActive = policy.invitations?.some(
    (invite: Invitation) => invite?.status === "active",
  );

  if (policy.do_not_invite) {
    return "doNotInvite";
  } else if (!someClaimed && !someActive) {
    return "invite";
  } else if (someActive) {
    return "invited";
  }
};

export const ExternalTeamIDInfo =
  "This external team ID is used to map organisations between the care system and external PAS systems and is required for successful policy ingestion. 'TEAM_XXXX'(SCREAMING_SNAKE_CASE) IDs are associated with Evari and 'ACC000001' or '1234456' style IDs are associated with Entsia.";
